import type { CSSProperties } from 'react';
import { css } from 'styled-components';

export const pagesWrapper = css`
  width: 100%;
  overflow: hidden;
`;

export interface PagesCSSProperties extends CSSProperties {
  '--translateX': string;
}

export const pages = css`
  display: flex;
  overflow: hidden;
  flex-grow: 1;
  transform: translate3d(var(--translateX), 0, 0);
`;
